import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import React from "react";
import { AiOutlineClose } from "react-icons/ai";

interface Props {
  onClose?: () => void;
  data?: any;
  title?: string;
}

const ViewDownloadDialog = ({ onClose, data, title }: Props) => {
  if (!data) return null;

  const txn = data?.Transactions;

  return (
    <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent>
        {/* Header */}
        <Box className="flex justify-between items-center border-b border-gray-300 pb-3 mb-3">
          <Typography variant="h6">{title || "Transaction Details"}</Typography>
          <Button onClick={onClose}>
            <AiOutlineClose size={20} />
          </Button>
        </Box>

        {/* Status Code & Message */}
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="subtitle2" color="textSecondary">Status Code</Typography>
            <Typography variant="body1">{data?.StatusCode ?? "N/A"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2" color="textSecondary">Message</Typography>
            <Typography variant="body1">{data?.Message || "N/A"}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="subtitle2" color="textSecondary">Transaction ID</Typography>
            <Typography variant="body1">{data?.TxnId || "N/A"}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2" color="textSecondary">Agent ID</Typography>
            <Typography variant="body1">{data?.AgentID || "N/A"}</Typography>
          </Grid>
        </Grid>

        {txn ? (
          <>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
              Transaction Info
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="textSecondary">Phone Number</Typography>
                <Typography variant="body1">{txn?.Number || "N/A"}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="textSecondary">Amount</Typography>
                <Typography variant="body1">&#x20B9; {txn?.Amount ?? "N/A"}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="subtitle2" color="textSecondary">Acknowledgement No</Typography>
                <Typography variant="body1">{txn?.AckNo || "N/A"}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="textSecondary">Order ID</Typography>
                <Typography variant="body1">{txn?.OrderID || "N/A"}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="subtitle2" color="textSecondary">Transaction Date</Typography>
                <Typography variant="body1">{txn?.TxnDate || "N/A"}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" color="textSecondary">Status</Typography>
                <Typography
                  variant="body1"
                  color={txn?.Status === "Success" ? "green" : "red"}
                  fontWeight="bold"
                >
                  {txn?.Status || "N/A"}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography variant="subtitle2" color="textSecondary">Type</Typography>
                <Typography variant="body1">{txn?.Type || "N/A"}</Typography>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            <Divider sx={{ my: 2 }} />
            <Typography variant="body2" color="textSecondary" textAlign="center">
              No transaction details available.
            </Typography>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ViewDownloadDialog;
